"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums");

var evaluateTrackData_1 = require("./evaluateTrackData");

exports.evaluateTracker = function (tracker, variableDictionary) {
  switch (tracker.type) {
    // With variables
    case enums_1.TrackerType.Perspective:
    case enums_1.TrackerType.ScaleAndTranslate:
      {
        return {
          type: tracker.type,
          trackData: evaluateTrackData_1.evaluateTrackData(tracker.trackData, variableDictionary)
        };
      }
  }
};